import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMe } from '../api/hooks';
import { useAuth } from '../auth/AuthProvider';
import { ErrorState, Loading } from '../components/States';

export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();
  if (auth.status === 'loading') return <Loading label="Checking your session…" />;
  if (auth.status === 'signed-out') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}

/** Sends each user to their home: MSP staff to the portal, client users to their tenant. */
export function HomeRedirect() {
  const me = useMe();
  if (me.isPending) return <Loading />;
  if (me.isError) return <ErrorState error={me.error} retry={() => me.refetch()} />;
  if (me.data.isMsp) return <Navigate to="/msp" replace />;
  const own = me.data.tenants[0];
  if (!own) {
    return (
      <div className="page" style={{ padding: 24 }}>
        <ErrorState error="Your account is not assigned to a tenant yet. Contact your service provider." />
      </div>
    );
  }
  return <Navigate to={`/t/${own.tenantId}/overview`} replace />;
}
